// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category {
  display: grid;
  grid-template-columns: 16.66% 1fr 16%;
  gap: 10px;
  align-items: start;
  padding: 0 16px !important;
  margin: 0 !important;
  box-sizing: border-box;
  min-height: 60vh;
}

app-listing-browse {
  display: block;
  width: 100%;
}

.category.right-sidebar-collapsed {
  grid-template-columns: 16.66% 1fr 56px;
}

.category.right-sidebar-collapsed .main-scroll-container {
  max-width: 100%;
}

.basic-filter-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 4px 8px;
  min-height: 48px;
}

.basic-filter-toolbar .keyword-search-field {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
}

.basic-filter-toolbar .keyword-field-compact {
  width: 100%;
}

.basic-filter-toolbar .keyword-field-compact.mat-mdc-form-field {
  --mat-form-field-container-height: 40px;
  --mat-form-field-container-vertical-padding: 8px;
}

.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.basic-filter-toolbar .keyword-field-compact .mat-mdc-text-field-wrapper {
  padding-bottom: 0;
}

.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-infix {
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.basic-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex: 0 0 auto;
  margin: 0 !important;
  padding: 0 !important;
  white-space: nowrap;
}

.all-filters-btn {
  margin-left: 0;
  line-height: 1.2;
  min-height: 36px;
  height: 36px;
  padding: 0 10px;
}
.all-filters-btn .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  vertical-align: middle;
}

.all-filters-btn.sidebar-mode-active {
  background: var(--brand-button-soft, rgba(37, 99, 235, 0.18));
  border-color: var(--brand-button, #2563eb);
}

.filter-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 4px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--brand-button, #2563eb);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

/* Left sidebar drawer controls: hidden on large screens, revealed at <=1210px. */
.left-sidebar-toggle-btn,
.left-sidebar-backdrop,
.left-sidebar-close {
  display: none;
}

.right-sidebar-backdrop {
  display: none;
}

.right-sidebar-chrome {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa;
  padding-bottom: 8px;
}

.right-sidebar-tabs {
  display: flex;
  flex: 1;
  gap: 4px;
  min-width: 0;
}

.right-sidebar-tab {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 36px;
  padding: 4px 8px;
  border: 1px solid color-mix(in srgb, var(--brand-button, #2563eb) 35%, transparent);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  color: rgba(0, 0, 0, 0.72);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.right-sidebar-tab .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.right-sidebar-tab.active {
  background: var(--brand-button-soft, rgba(37, 99, 235, 0.2));
  border-color: var(--brand-button, #2563eb);
  color: var(--brand-button-hover, #1d4ed8);
}

.right-sidebar-close {
  display: inline-flex;
  flex: 0 0 auto;
  background: white;
}

.right-sidebar-rail-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
}

.right-sidebar-rail-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid color-mix(in srgb, var(--brand-button, #2563eb) 30%, transparent);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.95);
  color: rgba(0, 0, 0, 0.72);
  cursor: pointer;
}
.right-sidebar-rail-btn .mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.right-sidebar-rail-btn .filter-count-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  margin-left: 0;
}
.right-sidebar-rail-btn:hover {
  background: var(--brand-button-soft, rgba(37, 99, 235, 0.14));
  border-color: var(--brand-button, #2563eb);
  color: var(--brand-button-hover, #1d4ed8);
}

.right-sidebar-filters-panel {
  padding: 0 4px 24px;
}
.right-sidebar-filters-panel .attribute-filter-field.col-md-2,
.right-sidebar-filters-panel .attribute-filter-field.col-md-4,
.right-sidebar-filters-panel .attribute-filter-field.col-sm-6 {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
}
.right-sidebar-filters-panel .attribute-filter.row {
  margin-left: 0;
  margin-right: 0;
}

.sidebar-filter-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.filters-panel {
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
}

.filters-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 12px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}
.filters-panel-header h6 {
  margin: 0;
  flex: 1 1 auto;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.7);
}
.filters-panel-header .mat-icon {
  color: rgba(0, 0, 0, 0.45);
}
.filters-panel-header:hover .mat-icon {
  color: var(--brand-button, #2563eb);
}

.filters-panel-body {
  padding: 0 4px 8px;
}

.filters-panel.is-collapsed {
  background: rgba(255, 255, 255, 0.85);
}

.sidebar-core-filters {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 4px;
}

.sidebar-core-filter {
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}

.sidebar-core-filter .attribute-range-filter {
  width: 100%;
  padding-top: 4px;
}

.sidebar-core-filter .range-filter-label {
  display: block;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
}

.sidebar-core-filter .mat-mdc-form-field {
  width: 100%;
}

.sidebar-filter-attributes-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  padding: 0 12px;
}

.active-filter-count {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.filter-link-btn {
  border: none;
  background: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--brand-font, var(--brand-accent, #2563eb));
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.filter-link-btn:hover {
  color: var(--brand-accent-hover, #1d4ed8);
}

@media (max-width: 1210px) {
  .basic-actions {
    margin-top: 0 !important;
  }
  .category,
  .category.right-sidebar-collapsed {
    grid-template-columns: 1fr 56px;
  }
  /* Collapsed: keep a thin icon rail in-flow so Filters/Tools stay reachable. */
  .sticky-right-sidebar.right-sidebar-rail {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 70px;
    width: 100%;
    max-width: none;
    height: auto;
    max-height: calc(100vh - 80px);
    box-shadow: none;
    overflow: visible;
  }
  .sticky-right-sidebar.right-sidebar-open {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: 480px;
    height: 100vh;
    max-height: 100vh;
    z-index: 10000;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.25);
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .right-sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
  }
  .sticky-sidebar {
    display: none;
  }
  .sticky-sidebar.left-sidebar-open {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 480px;
    height: 100vh;
    max-height: none;
    z-index: 10000;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);
    overflow-y: auto;
  }
  .sticky-sidebar.left-sidebar-open .left-sidebar-close {
    display: inline-flex;
    position: sticky;
    top: 8px;
    float: right;
    margin: 0 0 0 auto;
    background: white;
    z-index: 1;
  }
  .sticky-sidebar.left-sidebar-open .d-none.d-sm-inline {
    display: inline !important;
  }
  .left-sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
  }
  .left-sidebar-toggle-btn {
    display: inline-flex;
  }
}
@media (min-width: 769px) and (max-width: 1210px) {
  .category,
  .category.right-sidebar-collapsed {
    grid-template-columns: 1fr 56px;
  }
}
@media (max-width: 768px) {
  .category,
  .category.right-sidebar-collapsed {
    grid-template-columns: 1fr 56px;
    gap: 8px;
    padding: 0 8px !important;
  }
  .main-scroll-container {
    order: 1;
    position: static;
    max-height: none;
    overflow: visible;
  }
  .scrollable-content {
    overflow: visible;
    max-height: none;
  }
  .sticky-header {
    position: sticky;
    top: 60px;
  }
  .sticky-sidebar {
    position: static;
    max-height: none;
  }
  .sticky-right-sidebar.right-sidebar-rail {
    position: sticky;
    top: 60px;
    max-height: calc(100vh - 70px);
  }
}
@media (max-width: 480px) {
  .sticky-sidebar {
    display: none;
  }
  .category,
  .category.right-sidebar-collapsed {
    grid-template-columns: 1fr 52px;
  }
}
.sticky-sidebar,
.sticky-right-sidebar {
  position: sticky;
  top: 70px;
  align-self: start;
  width: 100%;
  max-height: calc(100vh - 80px);
  overflow-x: hidden;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  background: #f8f9fa;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}
.sticky-sidebar::-webkit-scrollbar,
.sticky-right-sidebar::-webkit-scrollbar {
  width: 6px;
}
.sticky-sidebar::-webkit-scrollbar-thumb,
.sticky-right-sidebar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 3px;
}

/* Left nav: keep content inset from the viewport / column edge. */
.sticky-sidebar {
  padding: 12px 12px 20px 20px;
}

.sticky-right-sidebar {
  padding: 10px 12px 24px;
}

.sticky-right-sidebar.right-sidebar-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 4px 16px;
  overflow: visible;
}

/* Ensure nested sidebar nav can extend and scroll inside the left rail. */
.sticky-sidebar app-sidebar,
.sticky-sidebar aside,
.sticky-sidebar .browse-sidebar-nav {
  display: block;
  width: 100%;
  max-width: 100%;
}

.sticky-sidebar .browse-sidebar-nav .nav-link span {
  display: inline-flex !important;
  white-space: normal;
}

.main-scroll-container {
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 70px;
  align-self: start;
  width: 100%;
  min-width: 0;
  max-height: calc(100vh - 80px);
  overflow: hidden;
  box-sizing: border-box;
}

.sticky-header {
  flex: 0 0 auto;
  position: relative;
  top: auto;
  background-color: #f3f3f3;
  padding: 0;
  border: 1px solid rgba(212, 175, 55, 0.2);
  z-index: 100;
}

.scrollable-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 10px;
  padding-bottom: 80px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}
.scrollable-content::-webkit-scrollbar {
  width: 6px;
}
.scrollable-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 3px;
}

.sticky-right-sidebar {
  display: block;
}

.right-sidebar-chrome {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa;
}

.right-sidebar-filters-panel,
.sticky-right-sidebar > app-rightbar {
  display: block;
}

.listing-filters-panel,
.filter-row {
  width: 100%;
}

.filter-row-primary .row {
  margin-left: 0;
  margin-right: 0;
  align-items: flex-end;
}

.fulfillment-chip {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  vertical-align: middle;
  color: #1e3a5f;
  background: #e8f1fb;
  border: 1px solid #c5daf5;
}

/* List view: 1-per-row marketplace cards. */
.listing-list-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.listing-list-row {
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr) 200px;
  gap: 0;
  align-items: stretch;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
  margin: 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.listing-list-row:hover {
  border-color: color-mix(in srgb, var(--brand-button, #2563eb) 35%, transparent);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.listing-list-media {
  display: block;
  align-self: stretch;
  text-decoration: none;
  cursor: pointer;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}

.listing-list-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 180px;
  max-height: 220px;
  overflow: hidden;
  background: #fff;
}

.listing-list-thumb__img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.listing-list-main {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 14px 18px;
}

.listing-list-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 18px;
}

.listing-list-location {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-list-title {
  margin: 0;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.listing-list-title a {
  color: #1a1a1a;
  text-decoration: none;
}
.listing-list-title a:hover {
  color: var(--brand-font, var(--brand-button, #2563eb));
}

.listing-list-description {
  margin: 0;
  color: rgba(0, 0, 0, 0.62);
  font-size: 0.92rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.listing-list-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.listing-list-chip {
  display: inline-block;
  max-width: 100%;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1f3f5;
  color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-list-category {
  margin: 0;
  margin-top: auto;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-list-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  padding: 14px 16px;
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  text-align: right;
}

.listing-list-price {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.01em;
}

.listing-list-seller {
  margin: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.listing-list-seller a {
  color: var(--brand-font, var(--brand-button, #2563eb));
  text-decoration: none;
  font-weight: 600;
}
.listing-list-seller a:hover {
  text-decoration: underline;
}

.listing-list-seller-label {
  margin-right: 6px;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 500;
}

.listing-list-stats {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  color: rgba(0, 0, 0, 0.5);
}

.listing-list-stat {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0 4px;
  font-size: 12px;
}
.listing-list-stat .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.listing-list-compare-btn {
  width: 34px;
  height: 34px;
  padding: 0;
}
.listing-list-compare-btn .mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.listing-list-info-btn {
  min-height: 34px;
  height: 34px;
  padding: 0 12px;
  line-height: 1;
  font-size: 12px;
  font-weight: 600;
}
.listing-list-info-btn .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.listing-list-load-more {
  padding: 48px 0 80px;
  text-align: center;
}

@media (max-width: 992px) {
  .listing-list-row {
    grid-template-columns: 160px minmax(0, 1fr) 160px;
  }
}
@media (max-width: 768px) {
  .listing-list-row {
    grid-template-columns: 120px minmax(0, 1fr);
    grid-template-areas: "media main" "side side";
  }
  .listing-list-media {
    grid-area: media;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
  }
  .listing-list-main {
    grid-area: main;
    padding: 12px;
  }
  .listing-list-side {
    grid-area: side;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding: 10px 12px;
  }
  .listing-list-thumb {
    min-height: 120px;
    max-height: 140px;
  }
  .listing-list-stats {
    justify-content: flex-start;
  }
}
/* Panel view: 4-up cards with a compact marketplace layout. */
.listing-panel-grid {
  margin-top: 10px;
  background-color: transparent;
}

.listing-panel-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.listing-panel-card:hover {
  border-color: color-mix(in srgb, var(--brand-button, #2563eb) 35%, transparent);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.listing-panel-media {
  display: block;
  cursor: pointer;
  text-decoration: none;
}

.listing-panel-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1/1;
  max-height: 220px;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.listing-panel-thumb__img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.listing-panel-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  padding: 12px 14px 8px;
}

.listing-panel-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 18px;
}

.listing-panel-location {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-panel-title {
  margin: 0;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.listing-panel-title a {
  color: #1a1a1a;
  text-decoration: none;
}
.listing-panel-title a:hover {
  color: var(--brand-font, var(--brand-button, #2563eb));
}

.listing-panel-price {
  margin: 2px 0 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.01em;
}

.listing-panel-seller {
  margin: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.listing-panel-seller a {
  color: var(--brand-font, var(--brand-button, #2563eb));
  text-decoration: none;
  font-weight: 600;
}
.listing-panel-seller a:hover {
  text-decoration: underline;
}

.listing-panel-seller-label {
  margin-right: 6px;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 500;
}

.listing-panel-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.listing-panel-chip {
  display: inline-block;
  max-width: 100%;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1f3f5;
  color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-panel-category {
  margin: 0;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-panel-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  padding: 8px 12px 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.listing-panel-info-btn {
  min-height: 34px;
  height: 34px;
  padding: 0 10px;
  line-height: 1;
  font-size: 12px;
  font-weight: 600;
}
.listing-panel-info-btn .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.listing-panel-stats {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: rgba(0, 0, 0, 0.5);
}

.listing-panel-stat {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0 4px;
  font-size: 12px;
}
.listing-panel-stat .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.listing-panel-compare-btn {
  width: 34px;
  height: 34px;
  padding: 0;
}
.listing-panel-compare-btn .mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.listing-panel-load-more {
  padding: 48px 0 80px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/category/listing-browse/listing-browse.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,uCAAA;EACA,gDAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AACJ;;AAGA;EACE,6DAAA;EACA,0CAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA,iFAAA;AACA;;;EAGE,aAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;EACE,OAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,mFAAA;EACA,kBAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAAF;AAEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,4DAAA;EACA,0CAAA;EACA,yCAAA;AADJ;;AAKA;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mFAAA;EACA,mBAAA;EACA,qCAAA;EACA,0BAAA;EACA,eAAA;AAFF;AAIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;AAHJ;AAME;EACE,6DAAA;EACA,0CAAA;EACA,yCAAA;AAJJ;;AAQA;EACE,mBAAA;AALF;AAOE;;;EAGE,cAAA;EACA,eAAA;EACA,WAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;AANJ;;AAUA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,qCAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAPF;AASE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAPJ;AAUE;EACE,0BAAA;AARJ;AAWE;EACE,mCAAA;AATJ;;AAaA;EACE,kBAAA;AAVF;;AAaA;EACE,qCAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAVF;;AAaA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAVF;;AAaA;EACE,WAAA;EACA,gBAAA;AAVF;;AAaA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,WAAA;AAVF;;AAaA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAVF;;AAaA;EACE,eAAA;EACA,yBAAA;AAVF;;AAaA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,sDAAA;EACA,eAAA;EACA,0BAAA;EACA,0BAAA;AAVF;AAYE;EACE,yCAAA;AAVJ;;AAcA;EACE;IACE,wBAAA;EAXF;EAcA;;IAEE,+BAAA;EAZF;EAeA,8EAAA;EACA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,SAAA;IACA,WAAA;IACA,eAAA;IACA,YAAA;IACA,8BAAA;IACA,gBAAA;IACA,iBAAA;EAbF;EAgBA;IACE,aAAA;IACA,sBAAA;IACA,eAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;IACA,iBAAA;IACA,cAAA;IACA,2CAAA;IACA,gBAAA;IACA,4BAAA;EAdF;EAiBA;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,+BAAA;IACA,aAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;IACE,cAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;IACA,gBAAA;IACA,cAAA;IACA,0CAAA;IACA,gBAAA;EAjBF;EAoBA;IACE,oBAAA;IACA,gBAAA;IACA,QAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,UAAA;EAlBF;EAqBA;IACE,0BAAA;EAnBF;EAsBA;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,+BAAA;IACA,aAAA;EApBF;EAuBA;IACE,oBAAA;EArBF;AACF;AAwBA;EACE;;IAEE,+BAAA;EAtBF;AACF;AAyBA;EACE;;IAEE,+BAAA;IACA,QAAA;IACA,yBAAA;EAvBF;EA0BA;IACE,QAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;EAxBF;EA2BA;IACE,iBAAA;IACA,gBAAA;EAzBF;EA4BA;IACE,gBAAA;IACA,SAAA;EA1BF;EA6BA;IACE,gBAAA;IACA,gBAAA;EA3BF;EA8BA;IACE,gBAAA;IACA,SAAA;IACA,8BAAA;EA5BF;AACF;AA+BA;EACE;IACE,aAAA;EA7BF;EAgCA;;IAEE,+BAAA;EA9BF;AACF;AAiCA;;EAEE,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;EASA,qBAAA;AAvCF;AAgCE;;EACE,UAAA;AA7BJ;AA+BE;;EACE,+BAAA;EACA,kBAAA;AA5BJ;;AAiCA,kEAAA;AACA;EACE,4BAAA;AA9BF;;AAiCA;EACE,uBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AA9BF;;AAiCA,0EAAA;AACA;;;EAGE,cAAA;EACA,WAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,+BAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;EACA,yCAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;EACA,iCAAA;EASA,qBAAA;AAtCF;AA+BE;EACE,UAAA;AA7BJ;AA+BE;EACE,+BAAA;EACA,kBAAA;AA7BJ;;AAkCA;EACE,cAAA;AA/BF;;AAkCA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;AA/BF;;AAkCA;;EAEE,cAAA;AA/BF;;AAkCA;;EAEE,WAAA;AA/BF;;AAmCE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAhCJ;;AAoCA;EACE,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AAjCF;;AAoCA,4CAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,iDAAA;EACA,MAAA;EACA,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,0DAAA;AAjCF;;AAoCA;EACE,+EAAA;EACA,0CAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,2CAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,SAAA;EACA,0CAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AAlCF;AAoCE;EACE,cAAA;EACA,qBAAA;AAlCJ;AAoCI;EACE,sDAAA;AAlCN;;AAuCA;EACE,SAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AApCF;;AAuCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AApCF;;AAuCA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;AApCF;;AAuCA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;AApCF;;AAuCA;EACE,SAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApCF;AAsCE;EACE,sDAAA;EACA,qBAAA;EACA,gBAAA;AApCJ;AAsCI;EACE,0BAAA;AApCN;;AAyCA;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;AAtCF;;AAyCA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,yBAAA;AAtCF;;AAyCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAtCF;AAwCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtCJ;;AA0CA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAvCF;AAyCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvCJ;;AA2CA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxCF;AA0CE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAxCJ;;AA4CA;EACE,oBAAA;EACA,kBAAA;AAzCF;;AA4CA;EACE;IACE,iDAAA;EAzCF;AACF;AA4CA;EACE;IACE,2CAAA;IACA,6CACE;EA3CJ;EA+CA;IACE,gBAAA;IACA,2CAAA;EA7CF;EAgDA;IACE,eAAA;IACA,aAAA;EA9CF;EAiDA;IACE,eAAA;IACA,mBAAA;IACA,eAAA;IACA,mBAAA;IACA,8BAAA;IACA,gBAAA;IACA,iBAAA;IACA,yCAAA;IACA,kBAAA;EA/CF;EAkDA;IACE,iBAAA;IACA,iBAAA;EAhDF;EAmDA;IACE,2BAAA;EAjDF;AACF;AAoDA,8DAAA;AACA;EACE,gBAAA;EACA,6BAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,0DAAA;AAlDF;;AAqDA;EACE,+EAAA;EACA,0CAAA;AAlDF;;AAqDA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlDF;;AAqDA;EACE,SAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AAnDF;AAqDE;EACE,cAAA;EACA,qBAAA;AAnDJ;AAqDI;EACE,sDAAA;AAnDN;;AAwDA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;AArDF;;AAwDA;EACE,SAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArDF;AAuDE;EACE,sDAAA;EACA,qBAAA;EACA,gBAAA;AArDJ;AAuDI;EACE,0BAAA;AArDN;;AA0DA;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAvDF;;AA0DA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvDF;;AA0DA;EACE,SAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,yCAAA;AAvDF;;AA0DA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvDF;AAyDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvDJ;;AA2DA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAxDF;;AA2DA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAxDF;AA0DE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxDJ;;AA4DA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAzDF;AA2DE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzDJ;;AA6DA;EACE,oBAAA;EACA,kBAAA;AA1DF","sourcesContent":[".category {\n  display: grid;\n  grid-template-columns: 16.66% 1fr 16%;\n  gap: 10px;\n  align-items: start;\n  padding: 0 16px !important;\n  margin: 0 !important;\n  box-sizing: border-box;\n  min-height: 60vh;\n}\n\napp-listing-browse {\n  display: block;\n  width: 100%;\n}\n\n.category.right-sidebar-collapsed {\n  grid-template-columns: 16.66% 1fr 56px;\n}\n\n.category.right-sidebar-collapsed .main-scroll-container {\n  max-width: 100%;\n}\n\n.basic-filter-toolbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 4px 8px;\n  min-height: 48px;\n}\n\n.basic-filter-toolbar .keyword-search-field {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0;\n}\n\n.basic-filter-toolbar .keyword-field-compact {\n  width: 100%;\n}\n\n.basic-filter-toolbar .keyword-field-compact.mat-mdc-form-field {\n  --mat-form-field-container-height: 40px;\n  --mat-form-field-container-vertical-padding: 8px;\n}\n\n.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-subscript-wrapper {\n  display: none;\n}\n\n.basic-filter-toolbar .keyword-field-compact .mat-mdc-text-field-wrapper {\n  padding-bottom: 0;\n}\n\n.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-infix {\n  min-height: 40px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.basic-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  flex: 0 0 auto;\n  margin: 0 !important;\n  padding: 0 !important;\n  white-space: nowrap;\n}\n\n.all-filters-btn {\n  margin-left: 0;\n  line-height: 1.2;\n  min-height: 36px;\n  height: 36px;\n  padding: 0 10px;\n\n  .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    margin-right: 4px;\n    vertical-align: middle;\n  }\n}\n\n.all-filters-btn.sidebar-mode-active {\n  background: var(--brand-button-soft, rgba(37, 99, 235, 0.18));\n  border-color: var(--brand-button, #2563eb);\n}\n\n.filter-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  margin-left: 4px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: var(--brand-button, #2563eb);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n/* Left sidebar drawer controls: hidden on large screens, revealed at <=1210px. */\n.left-sidebar-toggle-btn,\n.left-sidebar-backdrop,\n.left-sidebar-close {\n  display: none;\n}\n\n.right-sidebar-backdrop {\n  display: none;\n}\n\n.right-sidebar-chrome {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 12px;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8f9fa;\n  padding-bottom: 8px;\n}\n\n.right-sidebar-tabs {\n  display: flex;\n  flex: 1;\n  gap: 4px;\n  min-width: 0;\n}\n\n.right-sidebar-tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 36px;\n  padding: 4px 8px;\n  border: 1px solid color-mix(in srgb, var(--brand-button, #2563eb) 35%, transparent);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.9);\n  color: rgba(0, 0, 0, 0.72);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n\n  .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &.active {\n    background: var(--brand-button-soft, rgba(37, 99, 235, 0.2));\n    border-color: var(--brand-button, #2563eb);\n    color: var(--brand-button-hover, #1d4ed8);\n  }\n}\n\n.right-sidebar-close {\n  display: inline-flex;\n  flex: 0 0 auto;\n  background: white;\n}\n\n.right-sidebar-rail-icons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 0;\n}\n\n.right-sidebar-rail-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid color-mix(in srgb, var(--brand-button, #2563eb) 30%, transparent);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.95);\n  color: rgba(0, 0, 0, 0.72);\n  cursor: pointer;\n\n  .mat-icon {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n  }\n\n  .filter-count-badge {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    margin-left: 0;\n  }\n\n  &:hover {\n    background: var(--brand-button-soft, rgba(37, 99, 235, 0.14));\n    border-color: var(--brand-button, #2563eb);\n    color: var(--brand-button-hover, #1d4ed8);\n  }\n}\n\n.right-sidebar-filters-panel {\n  padding: 0 4px 24px;\n\n  .attribute-filter-field.col-md-2,\n  .attribute-filter-field.col-md-4,\n  .attribute-filter-field.col-sm-6 {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .attribute-filter.row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n.sidebar-filter-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.filters-panel {\n  margin-bottom: 12px;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.filters-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  margin: 0;\n  padding: 12px 14px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n\n  h6 {\n    margin: 0;\n    flex: 1 1 auto;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba(0, 0, 0, 0.7);\n  }\n\n  .mat-icon {\n    color: rgba(0, 0, 0, 0.45);\n  }\n\n  &:hover .mat-icon {\n    color: var(--brand-button, #2563eb);\n  }\n}\n\n.filters-panel-body {\n  padding: 0 4px 8px;\n}\n\n.filters-panel.is-collapsed {\n  background: rgba(255, 255, 255, 0.85);\n}\n\n.sidebar-core-filters {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.sidebar-core-filter {\n  width: 100%;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.sidebar-core-filter .attribute-range-filter {\n  width: 100%;\n  padding-top: 4px;\n}\n\n.sidebar-core-filter .range-filter-label {\n  display: block;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.7);\n  margin-bottom: 8px;\n}\n\n.sidebar-core-filter .mat-mdc-form-field {\n  width: 100%;\n}\n\n.sidebar-filter-attributes-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n  padding: 0 12px;\n}\n\n.active-filter-count {\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.filter-link-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--brand-font, var(--brand-accent, #2563eb));\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n\n  &:hover {\n    color: var(--brand-accent-hover, #1d4ed8);\n  }\n}\n\n@media (max-width: 1210px) {\n  .basic-actions {\n    margin-top: 0 !important;\n  }\n\n  .category,\n  .category.right-sidebar-collapsed {\n    grid-template-columns: 1fr 56px;\n  }\n\n  /* Collapsed: keep a thin icon rail in-flow so Filters/Tools stay reachable. */\n  .sticky-right-sidebar.right-sidebar-rail {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: sticky;\n    top: 70px;\n    width: 100%;\n    max-width: none;\n    height: auto;\n    max-height: calc(100vh - 80px);\n    box-shadow: none;\n    overflow: visible;\n  }\n\n  .sticky-right-sidebar.right-sidebar-open {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 100%;\n    max-width: 480px;\n    height: 100vh;\n    max-height: 100vh;\n    z-index: 10000;\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.25);\n    overflow-y: auto;\n    overscroll-behavior: contain;\n  }\n\n  .right-sidebar-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    z-index: 9999;\n  }\n\n  .sticky-sidebar {\n    display: none;\n  }\n\n  .sticky-sidebar.left-sidebar-open {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    max-width: 480px;\n    height: 100vh;\n    max-height: none;\n    z-index: 10000;\n    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);\n    overflow-y: auto;\n  }\n\n  .sticky-sidebar.left-sidebar-open .left-sidebar-close {\n    display: inline-flex;\n    position: sticky;\n    top: 8px;\n    float: right;\n    margin: 0 0 0 auto;\n    background: white;\n    z-index: 1;\n  }\n\n  .sticky-sidebar.left-sidebar-open .d-none.d-sm-inline {\n    display: inline !important;\n  }\n\n  .left-sidebar-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    z-index: 9999;\n  }\n\n  .left-sidebar-toggle-btn {\n    display: inline-flex;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1210px) {\n  .category,\n  .category.right-sidebar-collapsed {\n    grid-template-columns: 1fr 56px;\n  }\n}\n\n@media (max-width: 768px) {\n  .category,\n  .category.right-sidebar-collapsed {\n    grid-template-columns: 1fr 56px;\n    gap: 8px;\n    padding: 0 8px !important;\n  }\n\n  .main-scroll-container {\n    order: 1;\n    position: static;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .scrollable-content {\n    overflow: visible;\n    max-height: none;\n  }\n\n  .sticky-header {\n    position: sticky;\n    top: 60px;\n  }\n\n  .sticky-sidebar {\n    position: static;\n    max-height: none;\n  }\n\n  .sticky-right-sidebar.right-sidebar-rail {\n    position: sticky;\n    top: 60px;\n    max-height: calc(100vh - 70px);\n  }\n}\n\n@media (max-width: 480px) {\n  .sticky-sidebar {\n    display: none;\n  }\n\n  .category,\n  .category.right-sidebar-collapsed {\n    grid-template-columns: 1fr 52px;\n  }\n}\n\n.sticky-sidebar,\n.sticky-right-sidebar {\n  position: sticky;\n  top: 70px;\n  align-self: start;\n  width: 100%;\n  max-height: calc(100vh - 80px);\n  overflow-x: hidden;\n  overflow-y: auto !important;\n  overscroll-behavior: contain;\n  background: #f8f9fa;\n  box-sizing: border-box;\n  -webkit-overflow-scrolling: touch;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.25);\n    border-radius: 3px;\n  }\n  scrollbar-width: thin;\n}\n\n/* Left nav: keep content inset from the viewport / column edge. */\n.sticky-sidebar {\n  padding: 12px 12px 20px 20px;\n}\n\n.sticky-right-sidebar {\n  padding: 10px 12px 24px;\n}\n\n.sticky-right-sidebar.right-sidebar-rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 4px 16px;\n  overflow: visible;\n}\n\n/* Ensure nested sidebar nav can extend and scroll inside the left rail. */\n.sticky-sidebar app-sidebar,\n.sticky-sidebar aside,\n.sticky-sidebar .browse-sidebar-nav {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.sticky-sidebar .browse-sidebar-nav .nav-link span {\n  display: inline-flex !important;\n  white-space: normal;\n}\n\n.main-scroll-container {\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: 70px;\n  align-self: start;\n  width: 100%;\n  min-width: 0;\n  max-height: calc(100vh - 80px);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.sticky-header {\n  flex: 0 0 auto;\n  position: relative;\n  top: auto;\n  background-color: #f3f3f3;\n  padding: 0;\n  border: 1px solid rgba(212,175,55,0.2);\n  z-index: 100;\n}\n\n.scrollable-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 10px;\n  padding-bottom: 80px;\n  -webkit-overflow-scrolling: touch;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.25);\n    border-radius: 3px;\n  }\n  scrollbar-width: thin;\n}\n\n.sticky-right-sidebar {\n  display: block;\n}\n\n.right-sidebar-chrome {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8f9fa;\n}\n\n.right-sidebar-filters-panel,\n.sticky-right-sidebar > app-rightbar {\n  display: block;\n}\n\n.listing-filters-panel,\n.filter-row {\n  width: 100%;\n}\n\n.filter-row-primary {\n  .row {\n    margin-left: 0;\n    margin-right: 0;\n    align-items: flex-end;\n  }\n}\n\n.fulfillment-chip {\n  display: inline-block;\n  margin-left: 0.5rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  vertical-align: middle;\n  color: #1e3a5f;\n  background: #e8f1fb;\n  border: 1px solid #c5daf5;\n}\n\n/* List view: 1-per-row marketplace cards. */\n.listing-list-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.listing-list-row {\n  display: grid;\n  grid-template-columns: 200px minmax(0, 1fr) 200px;\n  gap: 0;\n  align-items: stretch;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n  margin: 0;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.listing-list-row:hover {\n  border-color: color-mix(in srgb, var(--brand-button, #2563eb) 35%, transparent);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n}\n\n.listing-list-media {\n  display: block;\n  align-self: stretch;\n  text-decoration: none;\n  cursor: pointer;\n  border-right: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.listing-list-thumb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: 180px;\n  max-height: 220px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.listing-list-thumb__img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.listing-list-main {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  padding: 14px 18px;\n}\n\n.listing-list-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 18px;\n}\n\n.listing-list-location {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: rgba(0, 0, 0, 0.45);\n  text-transform: uppercase;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listing-list-title {\n  margin: 0;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 1.1rem;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n\n  a {\n    color: #1a1a1a;\n    text-decoration: none;\n\n    &:hover {\n      color: var(--brand-font, var(--brand-button, #2563eb));\n    }\n  }\n}\n\n.listing-list-description {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.62);\n  font-size: 0.92rem;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.listing-list-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.listing-list-chip {\n  display: inline-block;\n  max-width: 100%;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f1f3f5;\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listing-list-category {\n  margin: 0;\n  margin-top: auto;\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.45);\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listing-list-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 14px 16px;\n  border-left: 1px solid rgba(0, 0, 0, 0.05);\n  text-align: right;\n}\n\n.listing-list-price {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111;\n  letter-spacing: -0.01em;\n}\n\n.listing-list-seller {\n  margin: 0;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.55);\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  a {\n    color: var(--brand-font, var(--brand-button, #2563eb));\n    text-decoration: none;\n    font-weight: 600;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.listing-list-seller-label {\n  margin-right: 6px;\n  color: rgba(0, 0, 0, 0.4);\n  font-weight: 500;\n}\n\n.listing-list-stats {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 2px;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.listing-list-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 4px;\n  font-size: 12px;\n\n  .mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.listing-list-compare-btn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n\n  .mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.listing-list-info-btn {\n  min-height: 34px;\n  height: 34px;\n  padding: 0 12px;\n  line-height: 1;\n  font-size: 12px;\n  font-weight: 600;\n\n  .mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    margin-right: 2px;\n  }\n}\n\n.listing-list-load-more {\n  padding: 48px 0 80px;\n  text-align: center;\n}\n\n@media (max-width: 992px) {\n  .listing-list-row {\n    grid-template-columns: 160px minmax(0, 1fr) 160px;\n  }\n}\n\n@media (max-width: 768px) {\n  .listing-list-row {\n    grid-template-columns: 120px minmax(0, 1fr);\n    grid-template-areas:\n      \"media main\"\n      \"side side\";\n  }\n\n  .listing-list-media {\n    grid-area: media;\n    border-right: 1px solid rgba(0, 0, 0, 0.06);\n  }\n\n  .listing-list-main {\n    grid-area: main;\n    padding: 12px;\n  }\n\n  .listing-list-side {\n    grid-area: side;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    text-align: left;\n    border-left: none;\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\n    padding: 10px 12px;\n  }\n\n  .listing-list-thumb {\n    min-height: 120px;\n    max-height: 140px;\n  }\n\n  .listing-list-stats {\n    justify-content: flex-start;\n  }\n}\n\n/* Panel view: 4-up cards with a compact marketplace layout. */\n.listing-panel-grid {\n  margin-top: 10px;\n  background-color: transparent;\n}\n\n.listing-panel-card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.listing-panel-card:hover {\n  border-color: color-mix(in srgb, var(--brand-button, #2563eb) 35%, transparent);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n}\n\n.listing-panel-media {\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.listing-panel-thumb {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  max-height: 220px;\n  overflow: hidden;\n  background: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.listing-panel-thumb__img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.listing-panel-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 12px 14px 8px;\n}\n\n.listing-panel-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 18px;\n}\n\n.listing-panel-location {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: rgba(0, 0, 0, 0.45);\n  text-transform: uppercase;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listing-panel-title {\n  margin: 0;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n\n  a {\n    color: #1a1a1a;\n    text-decoration: none;\n\n    &:hover {\n      color: var(--brand-font, var(--brand-button, #2563eb));\n    }\n  }\n}\n\n.listing-panel-price {\n  margin: 2px 0 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #111;\n  letter-spacing: -0.01em;\n}\n\n.listing-panel-seller {\n  margin: 0;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  a {\n    color: var(--brand-font, var(--brand-button, #2563eb));\n    text-decoration: none;\n    font-weight: 600;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.listing-panel-seller-label {\n  margin-right: 6px;\n  color: rgba(0, 0, 0, 0.4);\n  font-weight: 500;\n}\n\n.listing-panel-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.listing-panel-chip {\n  display: inline-block;\n  max-width: 100%;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f1f3f5;\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listing-panel-category {\n  margin: 0;\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.45);\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listing-panel-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: auto;\n  padding: 8px 12px 12px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.listing-panel-info-btn {\n  min-height: 34px;\n  height: 34px;\n  padding: 0 10px;\n  line-height: 1;\n  font-size: 12px;\n  font-weight: 600;\n\n  .mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    margin-right: 2px;\n  }\n}\n\n.listing-panel-stats {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.listing-panel-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 4px;\n  font-size: 12px;\n\n  .mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.listing-panel-compare-btn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n\n  .mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.listing-panel-load-more {\n  padding: 48px 0 80px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
